import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-242a6c1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aside-wrap" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "store-info-wrap" }
const _hoisted_7 = { class: "menu-warp" }
const _hoisted_8 = ["index", "onClick"]

import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useLoginUserDetailStore } from '@/store/index';
import api from '@/api/request';
import logo from '@/assets/img/logo.png';
import iconHome from '@/assets/img/icon_home.png';
import iconMenu from '@/assets/img/icon_menu.png';
import { useAuthorityStore } from '@/store/modules/useAuthorityStore';
import { AppEnv } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    menus: {}
  },
  setup(__props: any) {

const props = __props;

watch(
  () => props.menus,
  () => {
    console.log('Watching');
  }
);

const menuData = ref<{ index: string; title: string; icon?: any }[]>([]);
const authorityStore = useAuthorityStore();

watch(
  () => authorityStore.systems,
  () => {
    menuData.value = authorityStore.systems
      .filter((value) => value.sid !== authorityStore.sid)
      .map((value) => ({
        title: value.sysName,
        icon: value.sysIcon,
        index: value.sysUrl
      }));
  },
  { immediate: true }
);

// TODO fixed home url
const onClickHome = () => {
  if (AppEnv.isProduction) {
    window.open('https://sz-home.ws.lingdong.cn/');
  } else {
    window.open('https://test-sz-home.ws.lingdong.cn/');
  }
};

const openUrl = (url: string) => {
  window.open(url);
};

const userDetailStore = useLoginUserDetailStore();
const router = useRouter();
const route = useRoute();

const active = ref<string>();
const name = ref(userDetailStore.userName);
const showModal = ref(false);
const popoverWrapVisible = ref(false);
const topPopoverVisible = ref(false);

const toPath = (menu: MenuItem) => {
  document.title = menu.resourceName;
  router.push({
    path: menu.resourceUrl
  });
};
watch(
  [() => route.path, () => props.menus],
  () => {
    props.menus?.forEach((value) => {
      console.log(value.resourceUrl, route.path);
      if (route.path.startsWith(value.resourceUrl)) {
        active.value = value.resourceUrl;
      }
    });
  },
  { immediate: true, deep: true }
);
watch(
  () => userDetailStore.userName,
  () => {
    name.value = userDetailStore.userName;
  }
);
userDetailStore.tryLoadUserDetail();

const hideMask = () => {
  showModal.value = false;
  popoverWrapVisible.value = false;
  topPopoverVisible.value = false;
};

const showPopoverWrap = () => {
  showModal.value = true;
  popoverWrapVisible.value = true;
};
const showTopPopover = () => {
  showModal.value = true;
  topPopoverVisible.value = true;
};
const logOut = () => {
  api.get('/sso/sign/logout', {}, {}, 'logoutBase');
  router.push({
    path: '/login'
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_e_typography = _resolveComponent("e-typography")!
  const _component_e_icon = _resolveComponent("e-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mask",
          onClick: hideMask
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_image, {
        src: _unref(iconHome),
        class: "icon",
        onClick: onClickHome
      }, null, 8, ["src"]),
      _createVNode(_component_el_popover, {
        placement: "right",
        width: 200,
        visible: topPopoverVisible.value
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_image, {
            src: _unref(iconMenu),
            class: "icon",
            onClick: showTopPopover
          }, null, 8, ["src"])
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuData.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.title,
              class: "popMenuItem",
              onClick: ($event: any) => (openUrl(item.index))
            }, [
              _createVNode(_component_el_image, {
                src: item.icon,
                class: "icon"
              }, null, 8, ["src"]),
              _createElementVNode("span", _hoisted_4, _toDisplayString(item.title), 1)
            ], 8, _hoisted_3))
          }), 128))
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createElementVNode("img", {
      src: _unref(logo),
      alt: "",
      class: "store-logo"
    }, null, 8, _hoisted_5),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_popover, {
        placement: "bottom",
        width: 128,
        visible: popoverWrapVisible.value
      }, {
        reference: _withCtx(() => [
          _createElementVNode("div", {
            class: "popover-inner",
            onClick: showPopoverWrap
          }, [
            _createVNode(_component_e_typography, {
              heading: "4",
              class: "white-color"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(name.value), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_e_icon, {
              type: "down",
              fill: "#fff",
              size: "16"
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_e_typography, {
            heading: "4",
            class: "pointer",
            onClick: logOut
          }, {
            default: _withCtx(() => [
              _createTextVNode("退出")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu) => {
        return (_openBlock(), _createElementBlock("div", {
          key: menu.projectId,
          index: menu.projectTag,
          class: _normalizeClass({
          item: true,
          'item-select': menu.resourceUrl === active.value
        }),
          onClick: () => toPath(menu)
        }, [
          (menu.icon)
            ? (_openBlock(), _createBlock(_component_el_image, {
                key: 0,
                src: menu.icon,
                class: _normalizeClass({ 'item-icon': true, 'item-sel-icon': menu.resourceUrl === active.value })
              }, null, 8, ["src", "class"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: _normalizeClass({ 'item-text': true, 'item-sel-text': menu.resourceUrl === active.value })
          }, _toDisplayString(menu.resourceName), 3)
        ], 10, _hoisted_8))
      }), 128))
    ])
  ]))
}
}

})